module.exports = __webpack_public_path__ + "img/change-img.90d1388b.png";